import { render } from "./ColumnModal.vue?vue&type=template&id=5cd6ffda&scoped=true"
import script from "./ColumnModal.vue?vue&type=script&lang=js"
export * from "./ColumnModal.vue?vue&type=script&lang=js"

import "./ColumnModal.vue?vue&type=style&index=0&id=5cd6ffda&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd6ffda"]])

export default __exports__